import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input } from "@angular/core";
var InfoIComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function InfoIComponent() {
        /**
         * Set our default values
         */
        this.localState = { value: "" };
    }
    InfoIComponent.prototype.ngOnInit = function () { };
    InfoIComponent.prototype.submitState = function (value) { };
    return InfoIComponent;
}());
export { InfoIComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/info-i/info-i.component.ts
// module id = null
// module chunks = 